module.exports = __webpack_public_path__ + "img/ring_y_s_1_0@2x.0d321561.png";